<!--
 * @Author: Tahiti
 * @Date: 2025-12-18
 * @Description: 试用样本图像组件 - 用户没有图像时可以选择使用
 * @FilePath: /weryai-web/components/Effects/SampleImages.vue
-->
<template>
    <div v-if="images && images.length > 0" class="sample-images">
        <label class="flex items-center text-white text-sm font-semibold mb-3">
            {{ label || t('effects.sampleImages') }}
        </label>
        <div class="flex gap-2 overflow-x-auto scrollbar-custom">
            <div
                v-for="(image, index) in images"
                :key="index"
                class="sample-image-item flex-shrink-0 cursor-pointer rounded-lg overflow-hidden border-2 transition-all duration-200"
                :class="selectedIndex === index ? 'border-[#99F768]' : 'border-transparent hover:border-white/30'"
                @click="handleSelect(image, index)"
            >
                <img
                    :src="image"
                    :alt="`Sample ${index + 1}`"
                    class="w-[60px] h-[60px] object-cover"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from '~/composables/useI18n'

const props = defineProps<{
    images?: string[]
    label?: string
    modelValue?: string
}>()

const emit = defineEmits<{
    'update:modelValue': [value: string]
    select: [image: string, index: number]
}>()

const { t } = useI18n()

const selectedIndex = ref<number | null>(null)

// 监听 modelValue 变化，更新选中状态
watch(() => props.modelValue, (newVal) => {
    if (newVal && props.images) {
        const index = props.images.indexOf(newVal)
        selectedIndex.value = index >= 0 ? index : null
    } else {
        selectedIndex.value = null
    }
}, { immediate: true })

const handleSelect = (image: string, index: number) => {
    selectedIndex.value = index
    emit('update:modelValue', image)
    emit('select', image, index)
}
</script>

<style lang="less" scoped>
.scrollbar-custom {
    scrollbar-width: none;
    -ms-overflow-style: none;
    
    &::-webkit-scrollbar {
        display: none;
    }
}

.sample-image-item {
    &:hover {
        transform: scale(1.05);
    }
}
</style>

